import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { questionnairesQueryOptions } from '@/app/(client)/questionnaires/-hooks/useQuestionnairesQuery';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/questionnaires/(pages)/(list)/my-questionnaires/active/',
)({
  loader: () =>
    queryClient.ensureQueryData(
      questionnairesQueryOptions({
        page: 1,
        count: 50,
        isArchived: false,
      }),
    ),
  component: lazyRouteComponent(
    () =>
      import(
        '@/app/(client)/questionnaires/-components/ActiveQuestionnairesTab'
      ),
    'ActiveQuestionnairesTab',
  ),
});
